import {
    GET_INVOICE_TYPES,
    GET_INVOICE_TYPE_DETAILS,
    CREATE_INVOICE_TYPE,
    UPDATE_INVOICE_TYPE,
    DELETE_INVOICE_TYPE
} from '../../index.types';


export function getInvoiceTypes(data) {
    return {
        type: GET_INVOICE_TYPES,
        data
    }
}

export function getInvoiceTypeDetails(data) {
    return {
        type: GET_INVOICE_TYPE_DETAILS,
        data
    }
}

export function createInvoiceType(data) {
    return {
        type: CREATE_INVOICE_TYPE,
        data
    }
}

export function updateInvoiceType(data) {
    return {
        type: UPDATE_INVOICE_TYPE,
        data
    }
}

export function deleteInvoiceType(data) {
    return {
        type: DELETE_INVOICE_TYPE,
        data
    }
}
